import { Table, Text } from '@mantine/core';

import { useArchiveAddon } from '../../api/archiveAddon';
import { useRestoreAddon } from '../../api/restoreAddon';
import { dictionaryTypes } from '../../types';
import { ArchiveToggle } from '../ArchiveToggle';

type Props = {
  addon: dictionaryTypes.Addon;
};

export const AddonsRow = ({ addon }: Props) => {
  const archive = useArchiveAddon();
  const restore = useRestoreAddon();

  const isArchived = Boolean(addon.archivedAt);

  return (
    <Table.Tr>
      <Table.Td>
        <Text size="sm">{addon.text}</Text>
      </Table.Td>
      <Table.Td>
        <ArchiveToggle
          isArchived={isArchived}
          isLoading={isArchived ? restore.isLoading : archive.isLoading}
          onArchive={() => archive.mutate({ _id: addon._id })}
          onRestore={() => restore.mutate({ _id: addon._id })}
        />
      </Table.Td>
    </Table.Tr>
  );
};
